import { submitAgentConversationMessageFeedback } from './agentConversationsApi';
import type {
  CommendaAiMessageFeedbackParams,
  CommendaAiMessageFeedbackResult,
} from './types';

export async function submitCommendaAiMessageFeedback({
  conversationId,
  messageId,
  rating,
  category,
  comment,
}: Readonly<CommendaAiMessageFeedbackParams>): Promise<CommendaAiMessageFeedbackResult> {
  return submitAgentConversationMessageFeedback(conversationId, messageId, {
    rating,
    ...(category ? { category } : {}),
    ...(comment?.trim() ? { comment: comment.trim() } : {}),
  });
}
